import { createModuleLayout } from "@/lib/create-module-layout";
import { MODULES } from "@kubdee/shared/module-ids";
import connectorsModule from "@kubdee/module-connectors";

/**
 * Shared layout for the Connectors module — hands the module manifest to the
 * factory so the sidebar, module guard, and breadcrumbs stay consistent with
 * the 11 other modules. Wiring into the top-level router happens in
 * `apps/web/src/router.tsx`.
 */
export default createModuleLayout({
  moduleId: MODULES.CONNECTORS,
  moduleConfig: connectorsModule,
});
